import { render, staticRenderFns } from "./secondTheme.vue?vue&type=template&id=61e8a1cc&"
import script from "./secondTheme.vue?vue&type=script&lang=js&"
export * from "./secondTheme.vue?vue&type=script&lang=js&"
import style0 from "./secondTheme.vue?vue&type=style&index=0&id=61e8a1cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports